export const reactions = [
  { name: "Yufei Wu", icons: "❤️‍🩹" },
  { name: "Yufei Wu", icons: "🙏" },
  { name: "Eric Zhang", icons: "💐" },
  { name: "Lyn Sahyoun", icons: "💐" },
  { name: "Mel Andrews", icons: "❤️‍🩹" },
  { name: "Abdelkader Haj Othman", icons: "🙏" },
  { name: "Alex Nelson", icons: "💚" },
  { name: "Andrew Kim", icons: "💐" },
  { name: "Andre Williams", icons: "🙏" },
  { name: "Shana Tracy", icons: "👏" },
  { name: "Michelle Therese van Rooyen", icons: "💚" },
  { name: "Nancy Zhang", icons: "❤️‍🩹" },
  { name: "Kavi Zaman", icons: "❤️‍🩹" },
  { name: "Pham Viet Ha", icons: "💐" },
  { name: "Jill P", icons: "❤️‍🩹" },
  { name: "Sudarshan Datta", icons: "❤️‍🩹" },
  { name: "Laura Silver ", icons: "💐" },
  { name: "Alex Taylor", icons: "🙏" },
  { name: "Jean Alzyad", icons: "💐" },
  { name: "Tori Flores", icons: "🙏" },
  { name: "Robert Riedy", icons: "🙏" },
  { name: "milgauser@t-online.de ", icons: "👏" },
  { name: "Michael Campbell", icons: "✨" },
  { name: "Bernadette Kelly", icons: "❤️‍🩹" },
  { name: "Crystal Sung", icons: "💐" },
  { name: "MELISSA DONCHI", icons: "❤️‍🩹" },
  { name: "Anastasia D W", icons: "✨" },
  { name: "Anastasia D W", icons: "💐" },
  { name: "sam collins", icons: "💚" },
  { name: "Lucas Prpic", icons: "💚" },
  { name: "Lucas Prpic", icons: "👏" },
  { name: "Lucas Prpic", icons: "✨" },
  { name: "Lucas Prpic", icons: "❤️‍🩹" },
  { name: "Lucas Prpic", icons: "🙏" },
  { name: "Lucas Prpic", icons: "💐" },
  { name: "Kerrie Duke", icons: "🙏" },
  { name: "Chengetai Kasitomo", icons: "💐" },
  { name: "Tenzin McMillan", icons: "❤️‍🩹" },
  { name: "Selim Kaloshi", icons: "🙏" },
  { name: "Sarah McGregor-Sloggett", icons: "💚" },
  { name: "Suchana Lama ", icons: "🙏" },
  { name: "Ay Issa", icons: "❤️‍🩹" },
  { name: "Cassandra Bellchambers", icons: "🙏" },
  { name: "Shayla Ponsford", icons: "💐" },
  { name: "Yuqing Chen", icons: "👏" },
  { name: "jenny betts", icons: "❤️‍🩹" },
  { name: "Keyara Stokes", icons: "🙏" },
  { name: "Megan Rowe", icons: "👏" },
  { name: "Poppy O ", icons: "❤️‍🩹" },
  { name: "Poppy O ", icons: "🙏" },
  { name: "Al James", icons: "❤️‍🩹" },
  { name: "Julie Follman", icons: "💚" },
  { name: "D B", icons: "🙏" },
  { name: "D B", icons: "✨" },
  { name: "D B", icons: "💐" },
  { name: "D B", icons: "💚" },
  { name: "D B", icons: "❤️‍🩹" },
  { name: "Cynthia Garton", icons: "🙏" },
  { name: "Cynthia Garton", icons: "✨" },
  { name: "Cynthia Garton", icons: "💚" },
];
